/**
 * Ensures a minimum period of time elapses before resolving or rejecting a Promise.
 * @param {Promise<T>} promise
 * @param {number} minTime
 * @return {Promise<T>}
 */
export const atLeast = <T>(promise: Promise<T>, minTime: number): Promise<T> => (
  new Promise((resolve, reject) => {
    let minTimeElapsed = false;
    let promiseCompleted = false;
    let resolvedValue: any;
    let rejectedValue: any;
    setTimeout(() => {
      minTimeElapsed = true;
      if (promiseCompleted && rejectedValue === undefined) {
        resolve(resolvedValue);
      } else if (promiseCompleted) {
        reject(rejectedValue);
      }
    }, minTime);
    promise
      .then((value: any) => {
        promiseCompleted = true;
        resolvedValue = value;
        if (minTimeElapsed) {
          resolve(value);
        }
      })
      .catch((error: any) => {
        promiseCompleted = true;
        rejectedValue = error;
        if (minTimeElapsed) {
          reject(error);
        }
      });
  })
);
